module.exports = __webpack_public_path__ + "img/logo3.b09666fd.png";